import styled from "styled-components";

export const SvgContainer = styled.div`
	display: inline-block;
	position: relative;
	width: 100%;
	max-height: 100%;
	height: 100%;
	vertical-align: middle;
	overflow: hidden;
	& svg {
		max-height: 100%;
		display: block;
		text-align: center;
		margin: 0 auto;
	}
`;
